import { AssetRunDryInfo } from "@hydrologiq/gql/graphql"
import Figure, { FigureProps } from "./Figure"
import FigureContent from "./FigureContent"
import { Link } from "@hydrologiq/shared/components/Link"
import { useIsSectionEnabled } from "@hydrologiq/shared/providers/SectionFeatures"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

export interface RunDryProps extends FigureProps {
  hours?: number
  location?: string
  asset?: string
  granularity?: "hours" | "days"
  customer?: string
  site?: string
  info?: AssetRunDryInfo
}

const RunDry = ({ hours, location, asset, customer, site, granularity = "hours", ...rest }: RunDryProps) => {
  const isCustomersEnabled = useIsSectionEnabled("customers")
  let value = hours ? Math.floor(hours) : 0
  const days = granularity === "days" ? hours : hours ? Math.floor((hours / 24) * 10) / 10 : 0

  const showDays = (granularity === "days" && days && days >= 1) || (granularity === "hours" && hours && hours > 0)

  if (!showDays && granularity === "days") value = days ? Math.floor(days * 24) : 0

  const contextLink = location ? (
    customer && site ? (
      <Link href={`/customers/${customer}/sites/${site}`} fontSize="xs" tooltip={location} deLink={!isCustomersEnabled} truncate>{location}</Link>
    ) : (
      <FigureContent.Label fontSize="xs" truncate>{asset ? `${location} · ${asset}` : location}</FigureContent.Label>
    )
  ) : asset ? (
    <FigureContent.Label fontSize="xs" truncate>{asset}</FigureContent.Label>
  ) : undefined

  return (
    <Figure {...rest} compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText link={contextLink}>estimated</FigureContent.SubText>
        <FigureContent.Value>
          {showDays ? days : value} {showDays ? "day" : "hour"}
          {(showDays && days && days > 1) || (value !== undefined && value !== 1) ? "s" : ""}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default RunDry
